import { PageHero } from '@components/common';
import { ImageCardGrid } from '@components/sections';
import { CALENDLY_URL } from '@constants';
import { knowledgeCards } from '@data/knowledgeCards';

export default function KnowledgeHubPage() {
  const hubStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'Knowledge Hub | The CISO Network',
    description:
      'Explore our knowledge hub for guides on fractional CISOs, cybersecurity terminology, and resources for security leaders.',
    url: 'https://thecisonetwork.com/knowledge-hub',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@type': 'Article',
            name: 'What is a Fractional CISO?',
            url: 'https://thecisonetwork.com/what-is-a-fractional-ciso',
          },
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@type': 'Article',
            name: 'Become a Fractional CISO',
            url: 'https://thecisonetwork.com/become-a-fractional-ciso',
          },
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@type': 'Article',
            name: 'Cybersecurity Frameworks Explained',
            url: 'https://thecisonetwork.com/knowledge-hub/cybersecurity-frameworks',
          },
        },
        {
          '@type': 'ListItem',
          position: 4,
          item: {
            '@type': 'DefinedTermSet',
            name: 'CISO Glossary',
            url: 'https://thecisonetwork.com/knowledge-hub/glossary',
          },
        },
      ],
    },
    publisher: {
      '@type': 'Organization',
      name: 'The CISO Network',
      url: 'https://thecisonetwork.com',
      logo: {
        '@type': 'ImageObject',
        url: 'https://thecisonetwork.com/images/logo.png',
      },
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(hubStructuredData) }}
      />
      <PageHero
        title="Knowledge Hub"
        subtitle="Guides, definitions, and resources for security leaders and the organisations they protect."
        eyebrow="Resources"
        seoTitle="Knowledge Hub | The CISO Network"
        seoDescription="Explore our knowledge hub for guides on fractional CISOs, cybersecurity terminology, and resources for security leaders."
      />

      <section className="py-24 bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-6">
              Learn from Our Experience
            </h2>
            <p className="text-lg text-muted-foreground">
              Whether you are exploring fractional CISO services for the first time, considering a
              career as one, or simply need to decode security jargon, our knowledge hub has you
              covered.
            </p>
          </div>

          <ImageCardGrid cards={knowledgeCards} />
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 gradient-navy cta-photo">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary-foreground mb-6">
            Still Have Questions?
          </h2>
          <p className="text-primary-foreground/60 text-lg max-w-3xl mx-auto mb-10">
            Our fractional CISOs are happy to talk through your situation - whether you are
            exploring security leadership for the first time or looking to join our network.
          </p>
          <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="btn-hero">
            Book a Call
          </a>
        </div>
      </section>
    </>
  );
}
